<label>{{ 'Register.Label.DistributorName' | translate }}<span *ngIf="showAsterisk"
        class="required-field">*</span></label>
<input [ngClass]="{'field-selected': isFilled}" name="distributor-name" [(ngModel)]="value" type="text"
    class="form-control">
